(function(){
  // KNOWLEDGE BASE — all answers pre-computed, zero API calls
  var KB = [
    { match: ['date','romantic','evening','sexy','night out','special occasion','dinner'],
      reply: 'For a date night, you want bold projection and lasting power. Browse our <a href="/collections/evening-fragrances-bold-scents-for-night" style="color:#b89368;">Evening Fragrances</a> — oriental and dark floral compositions built for impact.' },
    { match: ['office','work','meeting','professional','colleagues','subtle','daytime'],
      reply: 'Office fragrances need to project moderately without overwhelming shared spaces. Browse <a href="/collections/fresh-aquatic-fragrances-clean-daily-scents" style="color:#b89368;">Fresh & Daily Wear</a> — clean, refined, universally appropriate.' },
    { match: ['gift','present','birthday','anniversary','christmas','father','mother','friend'],
      reply: 'Our curated <a href="/collections/gift-sets" style="color:#b89368;">Fragrance Gift Sets</a> make the perfect impression for any occasion. Ready to give, beautifully presented.' },
    { match: ['cheap','affordable','budget','under 50','50 dollar','inexpensive','value'],
      reply: 'Our <a href="/collections/under-50" style="color:#b89368;">Under $50 collection</a> has authentic designer fragrances — same quality, no department store markup.' },
    { match: ['luxury','expensive','premium','best','high end'],
      reply: 'For the finest in perfumery, browse our <a href="/collections/premium-luxury-fragrances-designer-scents-100" style="color:#b89368;">Luxury & Designer collection</a> — Creed, Versace, Yves Saint Laurent, and more, all 100% authentic.' },
    { match: ['men','man','boyfriend','husband','masculine','guy','brother','dad','father','him'],
      reply: 'Browse <a href="/collections/mens-fragrances" style="color:#b89368;">Men’s Fragrances</a> — authentic scents from fresh aquatics to bold orientals. Filter by price or scent family.' },
    { match: ['women','woman','girlfriend','wife','feminine','girl','sister','mom','mother','her'],
      reply: 'Browse <a href="/collections/womens-fragrances" style="color:#b89368;">Women’s Fragrances</a> — authentic scents from delicate florals to sensual orientals.' },
    { match: ['unisex','neutral','anyone','both','gender'],
      reply: 'Our <a href="/collections/unisex-fragrances" style="color:#b89368;">Unisex collection</a> has boundary-free fragrances — clean musks, ouds, and woods that smell extraordinary on anyone.' },
    { match: ['oud','arabic','middle east','resin','incense','smoky'],
      reply: 'Oud is the most prestigious fragrance material — resinous, smoky, deeply complex. Browse <a href="/collections/oriental-fragrances-warm-exotic-scents" style="color:#b89368;">Oriental & Oud Fragrances</a>.' },
    { match: ['floral','flower','rose','jasmine','peony'],
      reply: 'Florals are the most diverse and wearable category. Browse <a href="/collections/floral-fragrances-romantic-feminine-scents" style="color:#b89368;">Floral Fragrances</a> — from light fresh roses to heady tuberose.' },
    { match: ['fresh','aquatic','clean','ocean','sea','citrus','summer'],
      reply: '<a href="/collections/fresh-aquatic-fragrances-clean-daily-scents" style="color:#b89368;">Fresh & Aquatic Fragrances</a> are energizing and universally wearable — ideal for daily wear, warm weather, and office environments.' },
    { match: ['sauvage','dior'],
      reply: 'We focus on authentic designer, niche, and Arabian houses, and our lineup changes often. Browse <a href="/collections/mens-fragrances" style="color:#b89368;">Men’s Fragrances</a> and filter by fresh or aromatic to explore that style, or try the <a href="/pages/oracle" style="color:#b89368;">Oracle Quiz</a> for a guided match.' },
    { match: ['aventus','creed'],
      reply: 'Creed Aventus is the benchmark luxury masculine fragrance — pineapple, birch, and ambroxan, with 10+ hour longevity. Browse our <a href="/collections/creed" style="color:#b89368;">Creed collection</a>.' },
    { match: ['bleu','chanel'],
      reply: 'We carry a wide range of woody and aromatic fragrances. Browse <a href="/collections/mens-fragrances" style="color:#b89368;">Men’s Fragrances</a> and filter by woody or aromatic to explore that style.' },
    { match: ['versace','eros'],
      reply: 'Versace Eros is a bold, fresh aromatic — mint, green apple, and vanilla, with strong projection. Browse our <a href="/collections/versace" style="color:#b89368;">Versace collection</a>.' },
    { match: ['boss','hugo'],
      reply: 'Hugo Boss Bottled is a classic masculine signature — warm apple and woody spice, excellent for daily wear. Browse our <a href="/collections/hugo-boss" style="color:#b89368;">Hugo Boss collection</a>.' },
    { match: ['ysl','yves saint laurent','saint laurent','la nuit','black opium','libre'],
      reply: 'Yves Saint Laurent blends Parisian elegance with modern edge — Y, La Nuit de L’Homme, Black Opium, Libre. Browse our <a href="/collections/yves-saint-laurent" style="color:#b89368;">Yves Saint Laurent collection</a>.' },
    { match: ['paco','rabanne','invictus','million','phantom'],
      reply: 'Paco Rabanne is daring and magnetic — 1 Million, Invictus, Lady Million. Browse our <a href="/collections/paco-rabanne" style="color:#b89368;">Paco Rabanne collection</a>.' },
    { match: ['gaultier','jean paul','le male','scandal'],
      reply: 'Jean Paul Gaultier is provocative and unmistakable — Le Male, Scandal. Browse our <a href="/collections/jean-paul-gaultier" style="color:#b89368;">Jean Paul Gaultier collection</a>.' },
    { match: ['carolina','herrera','good girl','212','bad boy'],
      reply: 'Carolina Herrera is elegant and modern — Good Girl, 212, Bad Boy. Browse our <a href="/collections/carolina-herrera" style="color:#b89368;">Carolina Herrera collection</a>.' },
    { match: ['edp','eau de parfum','difference','edt','concentration'],
      reply: 'EDP (15-20% oils) lasts 5-8 hours with strong projection. EDT (8-12% oils) lasts 3-5 hours — lighter and better for daily wear. For longevity, always choose EDP.' },
    { match: ['last','longevity','how long','all day'],
      reply: 'Longevity depends on concentration and base notes. EDP lasts 5-8 hours, Parfum 8-12+. Fragrances with amber, musk, and woody base notes anchor longest on skin.' },
    { match: ['apply','wear','spray','how much','how many'],
      reply: 'Apply to pulse points: inner wrists, neck, behind ears. EDP: 2-4 sprays. Don’t rub wrists together — it breaks the top notes. Moisturized skin holds fragrance longer.' },
    { match: ['notes','top','heart','base','pyramid'],
      reply: 'Top notes open the fragrance (first 15 min). Heart notes are the core (30min-3hrs). Base notes are what lingers all day (3hrs+). Never judge a fragrance solely on the opening.' },
    { match: ['return','refund','exchange'],
      reply: 'We offer a 30-day return policy on unopened fragrances. For return requests, email <a href="mailto:ironledgercapitolllc@gmail.com" style="color:#b89368;">ironledgercapitolllc@gmail.com</a> with your order number.' },
    { match: ['shipping','delivery','fast','how long','ship'],
      reply: 'We ship nationwide. Standard delivery is typically 5-15 business days after a 1-5 business day processing window, with expedited options at checkout. Free standard shipping on orders over $100 (applied automatically).' },
    { match: ['authentic','real','genuine','fake','counterfeit'],
      reply: 'Every fragrance at colognecapitol.com is 100% authentic, sourced through verified distributors. No gray market, no counterfeits.' },
    { match: ['discount','promo','code','coupon','sale','off'],
      reply: 'Check the banner at the top of the site for any current promotions, and enter your code at checkout to apply it.' },
    { match: ['contact','email','phone','help','support'],
      reply: 'Reach us at <a href="mailto:ironledgercapitolllc@gmail.com" style="color:#b89368;">ironledgercapitolllc@gmail.com</a> and we’ll be glad to help.' },
  ];

  var CHIPS_INIT = ['Date night scent','Under $50','Best for men','Gift ideas','Shipping & returns','How long does it last?'];
  var FALLBACK_RECS = [
    { text: "Browse Men's Fragrances", url: '/collections/mens-fragrances' },
    { text: "Browse Women's Fragrances", url: '/collections/womens-fragrances' },
    { text: 'Under $50', url: '/collections/under-50' },
    { text: 'Gift Sets', url: '/collections/gift-sets' },
    { text: 'Take the Fragrance Quiz', url: '/pages/fragrance-quiz' },
  ];

  var isOpen = false;
  var msgs = document.getElementById('cc-msgs');
  var chipBar = document.getElementById('cc-chips');
  if (!msgs || !chipBar) return;

  function addMsg(html, role) {
    var d = document.createElement('div');
    d.style.cssText = 'max-width:88%;padding:0.75rem 1rem;font-size:0.82rem;line-height:1.65;word-break:break-word;';
    if (role === 'user') {
      d.style.cssText += 'background:rgba(184,147,104,0.15);border:1px solid rgba(184,147,104,0.3);color:#f0e8d8;align-self:flex-end;';
      d.textContent = html;
    } else {
      d.style.cssText += 'background:#0f0a0a;border:1px solid rgba(184,147,104,0.12);color:#ccc;align-self:flex-start;';
      d.innerHTML = html;
    }
    msgs.appendChild(d);
    msgs.scrollTop = msgs.scrollHeight;
  }

  function addTyping() {
    var d = document.createElement('div');
    d.id = 'cc-typing';
    d.style.cssText = 'background:#0f0a0a;border:1px solid rgba(184,147,104,0.12);padding:0.75rem 1rem;align-self:flex-start;display:inline-flex;gap:4px;';
    for (var i=0;i<3;i++) {
      var s = document.createElement('span');
      s.style.cssText = 'width:6px;height:6px;border-radius:50%;background:#b89368;animation:ccbounce 1s infinite ' + (i*0.15) + 's;';
      d.appendChild(s);
    }
    msgs.appendChild(d);
    msgs.scrollTop = msgs.scrollHeight;
  }

  function removeTyping() { var t=document.getElementById('cc-typing'); if(t) t.remove(); }

  function setChips(items) {
    chipBar.innerHTML = '';
    items.forEach(function(c) {
      var b = document.createElement('button');
      b.style.cssText = 'padding:0.28rem 0.65rem;border:1px solid rgba(184,147,104,0.2);background:transparent;color:var(--dim);font-family:Jost,sans-serif;font-size:0.62rem;cursor:pointer;letter-spacing:0.04em;';
      b.textContent = typeof c === 'string' ? c : c.text;
      b.onclick = function() {
        if (typeof c === 'string') respond(c);
        else window.location.href = c.url;
      };
      chipBar.appendChild(b);
    });
  }

  function respond(q) {
    addMsg(q, 'user');
    chipBar.innerHTML = '';
    addTyping();
    setTimeout(function() {
      removeTyping();
      var ql = q.toLowerCase();
      var matched = false;
      for (var i=0; i<KB.length; i++) {
        for (var j=0; j<KB[i].match.length; j++) {
          if (ql.indexOf(KB[i].match[j]) !== -1) {
            addMsg(KB[i].reply, 'bot');
            matched = true;
            if (KB[i].match.indexOf('men') !== -1 || KB[i].match.indexOf('him') !== -1) {
              setChips(['Under $100','Date night scent','Gift for him']);
            } else if (KB[i].match.indexOf('women') !== -1 || KB[i].match.indexOf('her') !== -1) {
              setChips(['Under $75','Floral picks','Gift for her']);
            } else {
              setChips(['Show me more','Shipping & returns','What do you recommend?']);
            }
            break;
          }
        }
        if (matched) break;
      }
      if (!matched) {
        addMsg('I’ll point you in the right direction. Browse the picks below, or try our <a href="/pages/fragrance-quiz" style="color:#b89368;">Fragrance Quiz</a> for guided recommendations.', 'bot');
        setChips(FALLBACK_RECS);
      }
    }, 600);
  }

  document.getElementById('cc-toggle').addEventListener('click', function() {
    isOpen = !isOpen;
    var panel = document.getElementById('cc-panel');
    panel.style.display = isOpen ? 'flex' : 'none';
    document.getElementById('cc-chat-icon').style.display = isOpen ? 'none' : 'block';
    document.getElementById('cc-close-icon').style.display = isOpen ? 'block' : 'none';
    this.style.transform = isOpen ? 'scale(0.92)' : 'scale(1)';
    if (isOpen && msgs.children.length === 0) {
      addMsg('Hello. I’m your fragrance concierge at colognecapitol.com. I can help you find your perfect scent from our collection of 1,600+ fragrances. What are you looking for?', 'bot');
      setChips(CHIPS_INIT);
      setTimeout(function() { document.getElementById('cc-input').focus(); }, 150);
    }
  });

  var inp = document.getElementById('cc-input');
  document.getElementById('cc-send').addEventListener('click', function() { if(inp.value.trim()) { respond(inp.value.trim()); inp.value=''; } });
  inp.addEventListener('keydown', function(e) { if(e.key==='Enter' && this.value.trim()) { respond(this.value.trim()); this.value=''; } });
})();
